interface AppSettings {
  downloadResultImmediately: boolean;
  defaultIncludePdfOnReport: boolean;
  // Add other settings here as needed
}

export class SettingsService {
  private static instance: SettingsService;
  
  private storageKey = 'app_settings';

  private defaultSettings: AppSettings = {
    downloadResultImmediately: true,
    defaultIncludePdfOnReport: false
  };

  private constructor() {
    // Initialize with default settings if none exist
    if (!localStorage.getItem(this.storageKey)) {
      this.saveSettings(this.defaultSettings);
    }
  }

  public static getInstance(): SettingsService {
    if (!SettingsService.instance) {
      SettingsService.instance = new SettingsService();
    }
    return SettingsService.instance;
  }

  public getSettings(): AppSettings {
    const settings = localStorage.getItem(this.storageKey);
    var result = settings ? { ...this.defaultSettings, ...JSON.parse(settings) } : this.defaultSettings;
    return result;
  }

  private saveSettings(settings: AppSettings): void {
    localStorage.setItem(this.storageKey, JSON.stringify(settings));
  }

  public updateSetting<K extends keyof AppSettings>(
    key: K,
    value: AppSettings[K]
  ): void {
    const currentSettings = this.getSettings();
    this.saveSettings({
      ...currentSettings,
      [key]: value
    });
  }

  public resetToDefaults(): void {
    this.saveSettings(this.defaultSettings);
  }
}

export const settingsService = SettingsService.getInstance();